import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { COOKIES_POLICY_URL } from "../constants";

const COOKIE_ITEM_NAME = "gdpr_form";

const CookiesForm = () => {
    const [displayForm, setDisplayForm] = useState(false);

    useEffect(() => {
        if (shouldDisplayForm()) {
            setDisplayForm(true);
        }
    }, []);

    const shouldDisplayForm = () => {
        let formShown = false;
        try {
            formShown = Cookies.get(COOKIE_ITEM_NAME);
        } catch (e) {
            console.error(e);
        }
        return !formShown;
    };

    const createFormElement = () => (
        <div className="cookie-modal">
            <div className="cookie-modal__info">
                Мы используем{" "}
                <a target="_blank" className="cookie-modal__link" href={COOKIES_POLICY_URL}>
                    cookie-файлы
                </a>
            </div>
            <button className="btn-simple" onClick={removeForm}>
                OK
            </button>
        </div>
    );

    const removeForm = () => {
        try {
            Cookies.set(COOKIE_ITEM_NAME, "true", { expires: 365 });
        } catch (e) {
            console.error(e);
        }
        setDisplayForm(false);
    };

    return displayForm ? createFormElement() : null;
};

export default CookiesForm;
